@if (showReload && isProduction) {
  <button mat-icon-button (click)="reload()">
    @if (withShake) {
      <mat-icon color="accent">system_update_alt</mat-icon>
    } @else {
      <mat-icon>system_update_alt</mat-icon>
    }
  </button>
}
